module.exports = __webpack_public_path__ + "static/media/Joe-Summers-Headshot.0e59c5f4.jpeg";